import { SET_HISTORY, CLEAR_HISTORY, REMOVE_HISTORY_ITEM } from '../../actions';

const history = (state = null, action) => {
    switch (action.type) {
        case SET_HISTORY:
            return action.payload;
        case CLEAR_HISTORY:
            return {};
        case REMOVE_HISTORY_ITEM: {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { [action.payload.id]: deletedValue, ...newState } = state || {};

            return newState;
        }
        default:
            return state;
    }
};

export default history;
